import styled from 'styled-components';

export const StyledTitle = styled.h2<{ $shouldShowEmptyState?: boolean }>`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.dashboardTitle};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: ${({ $shouldShowEmptyState }) => ($shouldShowEmptyState ? '2.4rem !important' : 'none')};

  &[data-type='league']::first-letter {
    text-transform: uppercase;
  }
`;

export const StyledDashboardTitle = styled(StyledTitle).attrs({ as: 'p' })`
  margin-bottom: 0;
`;

export const StyledDashboardSubtitle = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  color: ${({ theme }) => theme.colors.grey[600]};
`;
